<template>
  <div class="mt-6">
    <div class="p-fluid p-formgrid p-grid" style="max-width: 90%; margin: 0 auto" v-if="newUser">
      <UpgradeBanner v-if="currentUser && !currentUser.upgraded" />
      <div class="p-field p-col-12 p-col-md-6">
        <h1 class="title is-2">{{ $t("Account.header") }}</h1>
      </div>
      <div class="p-field p-col-12 p-md-6">
        <label for="firstname6">{{ $t("Account.first_name") }}</label>
        <InputText
          id="firstname6"
          v-model="newUser.first"
          :placeholder="$t('e-g-hank')"
          type="text"
          :class="!newUser.first && 'p-invalid'"
        />
      </div>
      <div class="p-field p-col-12 p-md-6">
        <label for="lastname6">{{ $t("Account.last_name") }}</label>
        <InputText
          id="lastname6"
          v-model="newUser.last"
          :placeholder="$t('e-g-smith')"
          type="text"
          :class="!newUser.last && 'p-invalid'"
        />
      </div>
      <div class="p-field p-col-12 p-md-6">
        <label for="email">{{ $t("Account.email") }}</label>
        <InputText
          id="email"
          :placeholder="$t('e-g-hank-smith-gmail-com')"
          type="email"
          v-model="newUser.email"
          :class="!newUser.email && 'p-invalid'"
        />
      </div>
      <div class="p-field p-col-12 p-md-6">
        <label for="timezone">{{ $t("Account.timezone") }}</label>
        <Dropdown
          @input="setOffset"
          name="timezone"
          style="height: 3em"
          :filter="true"
          :options="timezones"
          optionLabel="name"
          optionValue="name"
          :placeholder="$t('Account.timezone_placeholder')"
          v-model="newUser.timezone"
        />
      </div>
      <div class="p-field p-col-12 p-md-6">
        <label for="timezone">{{ $t("Account.first_day") }}</label>
        <Dropdown
          name="timezone"
          style="height: 3em"
          :options="hiddenDays"
          optionLabel="name"
          optionValue="value"
          :placeholder="$t('select-day')"
          v-model="newUser.first_day"
        />
      </div>

      <div class="p-field p-col-12 p-md-6">
        <label for="language">{{ $t("Account.language") }}</label>
        <LocaleSwitcher />
      </div>

      <div class="p-field p-col-12 p-md-6">
        <label for="timezone">{{ $t("Account.hiddenDays") }}</label>
        <div class="p-field-checkbox" v-for="t in hiddenDays" :key="t.id">
          <Checkbox :id="t.name" :name="t.name" :value="t.value" v-model="newUser.hidden" />
          <label :for="t.name">{{ t.name }} </label>
        </div>
        <br /><br />
      </div>

      <div class="p-field p-col-12">
        <div style="width: 150px; margin: 0 auto">
          <Button :label="$t('Button.save')" :disabled="!isValid" @click="updateUser" class="p-button-lg" />
        </div>
      </div>

      <div v-if="!isProduction">
        {{ newUser }}
      </div>
    </div>

    <Dialog
      :header="this.$t('email-change-request-header')"
      :visible.sync="emailChangeDialog"
      :style="{ width: '600px', maxWidth: '90vw' }"
      :modal="true"
    >
      <div>
        {{ $t('email-change-message') }}
      </div>
    </Dialog>
  </div>
</template>

<script>
import api from "@/api";
import LocaleSwitcher from "../components/LocaleSwitcher.vue";

export default {
  components: { LocaleSwitcher },
  computed: {
    isValid() {
      return (
        this.newUser.first.length &&
        this.newUser.last &&
        this.newUser.last.length &&
        this.validateEmail(this.newUser.email) &&
        !!this.newUser.timezone
      );
    },
  },
  methods: {
    setOffset(val) {
      console.log("Set offset...", val);
      var offset = "+0:00";
      this.timezones.forEach(t => {
        if (t.name == val) {
          console.log(t);
          var x = t.offset.split("GMT")[1];
          if (x) {
            console.log(x);
            this.newUser.timezone_offset = x;
          }
        }
      });
    },
    updateUser() {
      console.log("Update");
      if (!this.isValid) {
        this.makeToast("info", this.$t("Toast.fix_info"));
        return;
      }
      api
        .updateUser(this.newUser)
        .then(response => {
          if (this.newUser.email !== this.currentUser.email) {
            this.emailChangeDialog = true;
          }
          this.makeToast("success", this.$t("Toast.update_settings"));
          this.$store.commit("setUser", response.data);
        })
        .catch(e => {
          this.makeToast("error", this.$t("Toast.error.update"));
        });
    },
  },
  data() {
    return {
      newUser: {
        first: "",
        last: "",
        email: "",
        timezone: "",
        first_day: 0,
        hidden: [],
      },
      emailChangeDialog: false,
      hiddenDays: [
        { name: this.$t("sunday"), value: 0 },
        { name: this.$t("monday"), value: 1 },
        { name: this.$t("tuesday"), value: 2 },
        { name: this.$t("wednesday"), value: 3 },
        { name: this.$t("thursday"), value: 4 },
        { name: this.$t("friday"), value: 5 },
        { name: this.$t("saturday"), value: 6 },
      ],
      days: [
        { name: this.$t("sunday"), value: 0 },
        { name: this.$t("monday"), value: 1 },
        { name: this.$t("saturday"), value: 6 },
      ],
      timezones: [
        {
          offset: "GMT-12:00",
          name: "Etc/GMT-12",
        },
        {
          offset: "GMT-11:00",
          name: "Etc/GMT-11",
        },
        {
          offset: "GMT-11:00",
          name: "Pacific/Midway",
        },
        {
          offset: "GMT-10:00",
          name: "America/Adak",
        },
        {
          offset: "GMT-09:00",
          name: "America/Anchorage",
        },
        {
          offset: "GMT-09:00",
          name: "Pacific/Gambier",
        },
        {
          offset: "GMT-08:00",
          name: "America/Dawson_Creek",
        },
        {
          offset: "GMT-08:00",
          name: "America/Ensenada",
        },
        {
          offset: "GMT-08:00",
          name: "America/Los_Angeles",
        },
        {
          offset: "GMT-07:00",
          name: "America/Chihuahua",
        },
        {
          offset: "GMT-07:00",
          name: "America/Phoenix",
        },
        {
          offset: "GMT-07:00",
          name: "America/Denver",
        },
        {
          offset: "GMT-06:00",
          name: "America/Belize",
        },
        {
          offset: "GMT-06:00",
          name: "America/Cancun",
        },
        {
          offset: "GMT-06:00",
          name: "America/Chicago",
        },
        {
          offset: "GMT-06:00",
          name: "Chile/EasterIsland",
        },
        {
          offset: "GMT-05:00",
          name: "America/Bogota",
        },
        {
          offset: "GMT-05:00",
          name: "America/Havana",
        },
        {
          offset: "GMT-05:00",
          name: "America/New_York",
        },
        {
          offset: "GMT-04:30",
          name: "America/Caracas",
        },
        {
          offset: "GMT-04:00",
          name: "America/Campo_Grande",
        },
        {
          offset: "GMT-04:00",
          name: "America/Glace_Bay",
        },
        {
          offset: "GMT-04:00",
          name: "America/Goose_Bay",
        },
        {
          offset: "GMT-04:00",
          name: "America/Santiago",
        },
        {
          offset: "GMT-04:00",
          name: "America/La_Paz",
        },
        {
          offset: "GMT-03:00",
          name: "America/Argentina/Buenos_Aires",
        },
        {
          offset: "GMT-03:00",
          name: "America/Montevideo",
        },
        {
          offset: "GMT-03:00",
          name: "America/Araguaina",
        },
        {
          offset: "GMT-03:00",
          name: "America/Godthab",
        },
        {
          offset: "GMT-03:00",
          name: "America/Miquelon",
        },
        {
          offset: "GMT-03:00",
          name: "America/Sao_Paulo",
        },
        {
          offset: "GMT-03:30",
          name: "America/St_Johns",
        },
        {
          offset: "GMT-02:00",
          name: "America/Noronha",
        },
        {
          offset: "GMT-01:00",
          name: "Atlantic/Cape_Verde",
        },
        {
          offset: "GMT",
          name: "Europe/Belfast",
        },
        {
          offset: "GMT",
          name: "Africa/Abidjan",
        },
        {
          offset: "GMT",
          name: "Europe/Dublin",
        },
        {
          offset: "GMT",
          name: "Europe/Lisbon",
        },
        {
          offset: "GMT",
          name: "Europe/London",
        },
        {
          offset: "UTC",
          name: "UTC",
        },
        {
          offset: "GMT+01:00",
          name: "Africa/Algiers",
        },
        {
          offset: "GMT+01:00",
          name: "Africa/Windhoek",
        },
        {
          offset: "GMT+01:00",
          name: "Atlantic/Azores",
        },
        {
          offset: "GMT+01:00",
          name: "Atlantic/Stanley",
        },
        {
          offset: "GMT+01:00",
          name: "Europe/Amsterdam",
        },
        {
          offset: "GMT+01:00",
          name: "Europe/Belgrade",
        },
        {
          offset: "GMT+01:00",
          name: "Europe/Brussels",
        },
        {
          offset: "GMT+02:00",
          name: "Africa/Cairo",
        },
        {
          offset: "GMT+02:00",
          name: "Africa/Blantyre",
        },
        {
          offset: "GMT+02:00",
          name: "Asia/Beirut",
        },
        {
          offset: "GMT+02:00",
          name: "Asia/Damascus",
        },
        {
          offset: "GMT+02:00",
          name: "Asia/Gaza",
        },
        {
          offset: "GMT+02:00",
          name: "Asia/Jerusalem",
        },
        {
          offset: "GMT+03:00",
          name: "Africa/Addis_Ababa",
        },
        {
          offset: "GMT+03:00",
          name: "Asia/Riyadh89",
        },
        {
          offset: "GMT+03:00",
          name: "Europe/Minsk",
        },
        {
          offset: "GMT+03:30",
          name: "Asia/Tehran",
        },
        {
          offset: "GMT+04:00",
          name: "Asia/Dubai",
        },
        {
          offset: "GMT+04:00",
          name: "Asia/Yerevan",
        },
        {
          offset: "GMT+04:00",
          name: "Europe/Moscow",
        },
        {
          offset: "GMT+04:30",
          name: "Asia/Kabul",
        },
        {
          offset: "GMT+05:00",
          name: "Asia/Tashkent",
        },
        {
          offset: "GMT+05:30",
          name: "Asia/Kolkata",
        },
        {
          offset: "GMT+05:45",
          name: "Asia/Katmandu",
        },
        {
          offset: "GMT+06:00",
          name: "Asia/Dhaka",
        },
        {
          offset: "GMT+06:00",
          name: "Asia/Yekaterinburg",
        },
        {
          offset: "GMT+06:30",
          name: "Asia/Rangoon",
        },
        {
          offset: "GMT+07:00",
          name: "Asia/Bangkok",
        },
        {
          offset: "GMT+07:00",
          name: "Asia/Novosibirsk",
        },
        {
          offset: "GMT+08:00",
          name: "Etc/GMT+8",
        },
        {
          offset: "GMT+08:00",
          name: "Asia/Hong_Kong",
        },
        {
          offset: "GMT+08:00",
          name: "Asia/Krasnoyarsk",
        },
        {
          offset: "GMT+08:00",
          name: "Australia/Perth",
        },
        {
          offset: "GMT+08:45",
          name: "Australia/Eucla",
        },
        {
          offset: "GMT+09:00",
          name: "Asia/Irkutsk",
        },
        {
          offset: "GMT+09:00",
          name: "Asia/Seoul",
        },
        {
          offset: "GMT+09:00",
          name: "Asia/Tokyo",
        },
        {
          offset: "GMT+09:30",
          name: "Australia/Adelaide",
        },
        {
          offset: "GMT+09:30",
          name: "Australia/Darwin",
        },
        {
          offset: "GMT+09:30",
          name: "Pacific/Marquesas",
        },
        {
          offset: "GMT+10:00",
          name: "Etc/GMT+10",
        },
        {
          offset: "GMT+10:00",
          name: "Australia/Brisbane",
        },
        {
          offset: "GMT+10:00",
          name: "Australia/Hobart",
        },
        {
          offset: "GMT+10:00",
          name: "Asia/Yakutsk",
        },
        {
          offset: "GMT+10:30",
          name: "Australia/Lord_Howe",
        },
        {
          offset: "GMT+11:00",
          name: "Asia/Vladivostok",
        },
        {
          offset: "GMT+11:30",
          name: "Pacific/Norfolk",
        },
        {
          offset: "GMT+12:00",
          name: "Etc/GMT+12",
        },
        {
          offset: "GMT+12:00",
          name: "Asia/Anadyr",
        },
        {
          offset: "GMT+12:00",
          name: "Asia/Magadan",
        },
        {
          offset: "GMT+12:00",
          name: "Pacific/Auckland",
        },
        {
          offset: "GMT+12:45",
          name: "Pacific/Chatham",
        },
        {
          offset: "GMT+13:00",
          name: "Pacific/Tongatapu",
        },
        {
          offset: "GMT+14:00",
          name: "Pacific/Kiritimati",
        },
      ],
    };
  },
  mounted() {
    const { first, last, email, timezone, first_day, hidden } = this.currentUser;
    this.newUser = {
      first,
      last,
      email,
      timezone,
      first_day,
      hidden,
    };
    this.timezones.sort(this.dynamicSort("name"));
  },
};
</script>

<style scoped lang="scss">
ul {
  list-style: circle;
  width: 200px;
  margin: 0 auto;
}
input {
  height: 3em;
}
</style>
